import AddCandidates from "./AddCandidates";
import CandidateTable from "./CandidateTable";

const RenderData = ({ hasMore }) => {
  return (
    <div className="min-h-full flex flex-col overflow-y-hidden">
      <AddCandidates />
      <CandidateTable hasMore={hasMore} />
    </div>
  );
};

export default RenderData;
